import ArrowIcon from '@/common/assets/icons/arrowRightIcon.svg?react';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import VideoImage from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/flowGuideVideoImage.png';
import { getTakePhotoGuideVideoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getTakePhotoGuideVideo/getTakePhotoGuideVideoQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex, Stack } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
export default ({
  open,
  closeModal,
}: MainModalProps & { nextStep: () => void }) => (
  <MainModal
    childrenWrapperClassName={css({
      height: '80vh',
      overflow: 'scroll',
      width: '90%',
    })}
    closeModal={closeModal}
    open={open}
  >
    <TakePhotoGuideModal />
  </MainModal>
);

const TakePhotoGuideModal = () => {
  const { damagedId, id } = useParams();

  const { data: fileVehicleType, isSuccess } = useQuery(
    getVehicleTypeQueryOption({ damaged_pk: damagedId, file_pk: id! }),
  );
  const { data: guideVideo } = useQuery(
    getTakePhotoGuideVideoQueryOptions({
      file_type: 'property',
      vehicle_type: fileVehicleType?.name!,
      enabled: isSuccess,
    }),
  );
  return (
    <Box>
      <TitleDescription>راهنمای عکس برداری</TitleDescription>

      <Typography textStyle="b2" color="black-1" my="1rem">
        کارشناس عزیز؛ جهت عکس‌برداری از وسیله‌نقلیه لازم است نکات زیر را مورد
        توجه قرار دهید .
      </Typography>
      <Stack mb="4rem">
        <Flex
          backgroundColor="white"
          boxShadow="cardShadow"
          borderRadius="8px"
          p="14px"
        >
          <Bullet />
          <Typography textStyle="b2" color="black-1" textAlign="justify">
            مراحل عکس‌برداری فرآیندی پیوسته را طی می‌کند، در صورت عدم گرفتن عکس
            تا پایان زمان تعیین شده، تمام فرآیند عکس‌برداری از ابتدا آغاز
            می‌شود.
          </Typography>
        </Flex>
        <Flex
          backgroundColor="white"
          boxShadow="cardShadow"
          borderRadius="8px"
          p="14px"
        >
          <Bullet />
          <Typography textStyle="b2" color="black-1" textAlign="justify">
            در مراحل عکس‌برداری لازم است گوشی خود را افقی نگه دارید، برای این
            کار می‌توانید نوار بالای گوشی خود را پایین کشیده و گزینه چرخش تصویر
            را غیرفعال کنید.
          </Typography>
        </Flex>
        <Flex
          backgroundColor="white"
          boxShadow="cardShadow"
          borderRadius="8px"
          p="14px"
        >
          <Bullet />
          <Typography textStyle="b2" color="black-1" textAlign="justify">
            به منظور در دست داشتن تصاویر بهتر، از فرآیند تصویربرداری شما ویدیویی
            تهیه می‌شود، به این ترتیب صدای محیط نیز در این ویدیو ضبط خواهد شد.
          </Typography>
        </Flex>
        <Flex
          backgroundColor="white"
          boxShadow="cardShadow"
          borderRadius="8px"
          p="14px"
          gap="1rem"
        >
          <Box flex={1}>
            <img
              className={css({ width: '100%', objectFit: 'cover' })}
              src={guideVideo?.image ?? VideoImage}
              alt=""
            />
          </Box>
          <Stack flex={1}>
            <Typography textStyle="b2" color="black-1">
              ویدیو راهنمای عکس‌برداری
            </Typography>
            <Typography textStyle="b3" color="black-2" textAlign="center">
              راهنمای گام به گام فرایند کارشناسی
            </Typography>
            <Flex
              onClick={() => {
                let el = document.createElement('a');
                el.id = 'videoLink';
                el.href = guideVideo?.video ?? '';
                el.target = '_blank';
                el.click();
                document.removeChild(el);
              }}
              alignItems={'center'}
              justifyContent="center"
              gap="0.2rem"
            >
              <Typography textStyle="b3" color="purple-2" textAlign="center">
                مشاهده ویدیو
              </Typography>
              <ArrowIcon stroke={token('colors.purple-2')} width={10} />{' '}
            </Flex>
          </Stack>
        </Flex>
      </Stack>
    </Box>
  );
};

const Bullet = () => {
  return (
    <Box
      flexShrink={0}
      backgroundColor="purple-2"
      className={css({
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        marginLeft: '10px',
        mt: '8px',
      })}
    />
  );
};
